import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { RoutingConstants } from "../constants/routingConstants";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { DateService } from "src/app/core/services/date.service";
import { TokenService } from "src/app/core/services/token.service";
import { CommonService } from "src/app/core/services/common.service";
import { TranslateService } from "@ngx-translate/core";
import { AppConstants } from "../constants/app.constants";
import { PersonalParamsService } from "./personal-params.service";
import * as moment from "moment";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";

@Component({
  selector: "app-configuration-personal-params",
  templateUrl: "./configuration-personal-params.component.html",
  styleUrls: ["./configuration-personal-params.component.css"],
})
export class ConfigurationPersonalParamsComponent implements OnInit {
  personalParams;
  usCaducidadAux;
  usCertificado: string;
  userId: string;
  typesMailBoxList = AppConstants.typesMailBox;
  frecuencyList = AppConstants.frecuency;
  roles = AppConstants.roles;
  file: any = null;
  today = moment().format("YYYY-MM-DD");

  @ViewChild("infoSwal")
  public readonly infoSwal!: SwalComponent;

  constructor(
    private toastrAlertService: ToastrAlertService,
    private tokenService: TokenService,
    private commonService: CommonService,
    private router: Router,
    private translateService: TranslateService,
    private personalParamsService: PersonalParamsService,
    private dateService: DateService
  ) {
    this.userId = this.tokenService.getUserName();
  }

  ngOnInit(): void {
    if (this.tokenService.hasRole(AppConstants.roles.RHOMOLOG)) {
      this.initFormHomologRole();
    } else {
      this.initForm();
    }
    this.getPersonalConfiguration();
  }

  initForm() {
    this.personalParams = new FormGroup({
      usId: new FormControl(this.userId),
      usBuzonPreferente: new FormControl(""),
      usLineas: new FormControl("", [Validators.required]),
      usPeriodicidad: new FormControl(""),
      usFultimoMail: new FormControl(null),
      usCaducidad: new FormControl(""),
      usCertificadoPwd: new FormControl(""),
      usCertificadoPwdConfirm: new FormControl(""),
      editCertificate: new FormControl(false),
    });
  }

  initFormHomologRole() {
    this.personalParams = new FormGroup({
      usId: new FormControl(this.userId),
      usBuzonPreferente: new FormControl(""),
      usLineas: new FormControl("", [Validators.required]),
      usPeriodicidad: new FormControl(""),
      usFultimoMail: new FormControl(null),
      usCaducidad: new FormControl(""),
      usCertificado: new FormControl(""),
      usCertificadoPwd: new FormControl(""),
      usCertificadoPwdConfirm: new FormControl(""),
      editCertificate: new FormControl(false),
    });
  }

  getPersonalConfiguration() {
    this.personalParamsService.getPersonalInfo(this.userId).subscribe(
      (data) => {
        data["usCaducidad"] = this.dateService.changeFormatDate(
          data["usCaducidad"],
          "YYYY-MM-DD"
        );
        this.setValues(data);
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  setValues(data) {
    this.personalParams.patchValue({
      usBuzonPreferente: data.usBuzonPreferente,
      usLineas: data.usPagina,
      usCaducidad: data.usCaducidad,
      usCertificado: data.usCertificado,
      usPeriodicidad: data.usPeriodicidad,
      usFultimoMail: data.usFultimoMail,
    });
  }

  handleFileInput(fileInput: any) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      this.personalParams.patchValue({
        usCertificado: fileInput.target.files[0].name,
      });
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.file = this.commonService.castToBlob(e.target.result);
      };

      reader.readAsDataURL(fileInput.target.files[0]);
    }
  }

  goPredefinedMailBox() {
    this.tokenService.redirectPredefinedMailBox();
  }

  onSave() {
    this.validations();
  }

  validations() {
    let invalidFields = this.commonService.findInvalidControls(
      this.personalParams.controls
    );
    if (invalidFields.length > 0) {
      let text = this.commonService.getValueOfLabelsById(invalidFields);
      this.toastrAlertService.toastrFail(text);
    } else if (this.personalParams.value.editCertificate) {
      if (
        this.tokenService.hasRole(AppConstants.roles.RHOMOLOG) &&
        this.personalParams.value.usCertificadoPwd !==
          this.personalParams.value.usCertificadoPwdConfirm
      ) {
        let message = this.translateService.instant(
          "messages.passwordConfirmationNotMatch"
        );
        this.toastrAlertService.toastrFail(message);
      } else {
        if (this.checkCertificateFields()) {
          this.onUpdate();
        }
      }
    } else {
      this.onUpdate();
    }
  }

  onUpdate() {
    this.personalParamsService
      .updatePersonalInfo(this.file, this.personalParams.value)
      .subscribe(
        (data) => {
          this.infoSwal.fire().then((result) => {
            if (result.isConfirmed) {
              this.goPredefinedMailBox();
            }
          });
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }

  checkCertificateFields(): boolean {
    let status: boolean = true;
    let message: string = "";
    if (this.personalParams.value.usCertificadoPwd === "") {
      message =
        message +
        this.translateService.instant(
          "messages.fieldsRequired.passwdRequired"
        ) +
        "<br/>";
      status = false;
    }
    if (this.personalParams.value.usCertificadoPwdConfirm === "") {
      message =
        message +
        this.translateService.instant("messages.fieldsRequired.passwdConfirm") +
        "<br/>";
      status = false;
    }
    if (this.file == null) {
      message =
        message +
        this.translateService.instant("messages.fieldsRequired.fileRequired") +
        "<br/>";
      status = false;
    }
    if (this.personalParams.value.usCaducidad == "") {
      message =
        message +
        this.translateService.instant("messages.fieldsRequired.fechaRequired") +
        "<br/>";
      status = false;
    }
    if (!status) {
      message =
        this.translateService.instant("messages.fieldsError") +
        "<br/>" +
        message;
      this.toastrAlertService.toastrFail(message);
    }

    return status;
  }

  resetForm() {
    if (!this.personalParams.value.editCertificate) {
      this.usCaducidadAux = this.personalParams.value.usCaducidad;
      this.usCertificado = this.personalParams.value.usCertificado;
      this.personalParams.patchValue({
        usCaducidad: "",
        usCertificado: "",
      });
    } else {
      this.personalParams.patchValue({
        usCaducidad: this.usCaducidadAux,
        usCertificado: this.usCertificado,
      });
    }
  }
}
